import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { FONT_FAMILY_REGULAR, X_SMALL_TEXT_PX, SEMANTIC_TEXT_SMALL_PX, FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';

export const MainWrapper = styled.div`
  width: 100%;
`;

export const ReservationMessageWrapper = styled.div`
  color: #C121EB;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : SEMANTIC_TEXT_SMALL_PX)};
  display: flex;
`;

export const ReservationMessageSpan = styled.span`
  margin-top: 6px;
  margin-left: 3px;
`;

export const DontShipText = styled.div`
  width: 22%;
  align-content: space-evenly;
  font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : FONT_FAMILY_REGULAR)};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : X_SMALL_TEXT_PX)};
`;

export const ItemContainer = styled.div`
  width: 100%;
`;

export const ItemBackground = styled.div`
  background: ${({ background }) => (background ? background : 'none')};
`;

export const Header = styled.div`
        display: flex;
        align-items: center;
        //  background: #f5f5f5 0% 0% no-repeat padding-box;
        background: #ebebeb 0% 0% no-repeat padding-box;
        margin-top: 20px;
        padding: 6px 0;
        /* padding-top: 10px;
        padding-bottom: 25px; */
        padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '20px')};
        width: ${({ width }) => (width ? width : '100%')};
        height: ${({ height }) => (height ? height : '38px')};
        text-align: left;
        //font:15px Avenir Next World;
        letter-spacing: 0px;
        text-transform: uppercase;
        opacity: 1;
        margin-bottom: ${({ marginBottom }) =>
            marginBottom ? marginBottom : '0px'};
        font-family: ${FONT_FAMILY_DEMI};
        font-size: ${SEMANTIC_TEXT_SMALL_PX};
        color: #5f5f5f;
    
        ${media.mobileDevice`
        margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '0')};
        margin-bottom: ${({ mbMarginBottom }) =>
            mbMarginBottom ? mbMarginBottom : '0'};
        /* padding-bottom: 30px; */
        padding: ${({ mobilePadding }) =>
            mobilePadding ? mobilePadding : '10px 0'};
        // extra space removed b/w tissue service label and shipping details
        // grey color applied from edge to edge
        height: ${({ mbHeight }) => mbHeight ? mbHeight : '33px'};
        
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : 'calc(100%)')};
        margin-left:${({ marginLeft }) => marginLeft && marginLeft};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '20px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
        align-items: center ;
        background-color: ${({ mbBackGroundColor }) =>
            mbBackGroundColor ? mbBackGroundColor : 'transparent'};
    `};
`;

export const HeaderContainer = styled.div`
    display: flex;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    width: 100%;
    background-color: ${({ mbBackGroundColor }) =>
        mbBackGroundColor ? mbBackGroundColor : '#EBEDED'};
`;
